import { ref as d, onMounted as m, onBeforeUnmount as p, createElementBlock as F, openBlock as b, createElementVNode as u, renderSlot as v } from "vue";
import { focusFirstFocusable as E, focusLastFocusable as w } from "../lib/utils.js";
const L = {
  __name: "TrapFocus",
  props: {
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  setup(s) {
    const a = s, r = d(null);
    let o = !1, n = null;
    function l(e) {
      if (!a.enabled || o) return;
      const t = Array.from(r.value.children).slice(1, -1);
      e.target !== window && (t.some((f) => f.contains(e.target)) ? n = e.target : (i({ children: t }), n === document.activeElement && c({ children: t }), n = document.activeElement));
    }
    function i(e) {
      o = !0, E(e), o = !1;
    }
    function c(e) {
      o = !0, w(e), o = !1;
    }
    return m(() => {
      window.addEventListener("focus", l, !0);
    }), p(() => {
      window.removeEventListener("focus", l, !0);
    }), (e, t) => (b(), F("div", {
      ref_key: "root",
      ref: r
    }, [
      t[0] || (t[0] = u("div", { tabindex: "0" }, null, -1)),
      v(e.$slots, "default"),
      t[1] || (t[1] = u("div", { tabindex: "0" }, null, -1))
    ], 512));
  }
};
export {
  L as default
};
